import { Skeleton } from '@repo/ui';

import { useAccessAdmins } from '@/hooks/auth/use-access-admins';

/** Names only, by design: this page is shown to someone with no role, who is not given anyone's email. */
export function AccessAdminsList() {
  const { data, isPending, isError } = useAccessAdmins();

  if (isPending) return <Skeleton className="h-4 w-48" />;

  if (isError || data.names.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        Ask your manager or whoever looks after Cyrino accounts in your company.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-1 text-sm">
      <span className="text-muted-foreground">To ask for access, contact one of these people:</span>
      <ul className="font-medium" data-testid="access-admins">
        {data.names.map((name) => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    </div>
  );
}
